import { createReducer, on } from '@ngrx/store';
import {
  getIndices,
  deleteIndex,
  deleteIndexId,
  saveIndex,
  setAllIndices,
  setIndex,
  setIndices,
  deleteSuccess,
  deleteError,
  setError
} from '../actions/indexdesigner.actions';

export interface IndexDesignerState {
  indexObjects: any;
}

export const initialState: IndexDesignerState = {
  indexObjects: []
};
export const indexDesignerReducer = createReducer(
  initialState,
  on(saveIndex, (state, { indexObject }) => ({
    ...state,
    ...{ indexObject }
  })),
  on(setIndex, (state, { savedIndex }) => ({
    ...state,
    ...{ savedIndex }
  })),
  on(setAllIndices, (state, { indexObjects }) => ({
    ...state,
    ...{ indexObjects }
  })),
  on(setIndices, (state, { indices }) => ({
    ...state,
    ...{ indices }
  })),
  on(getIndices, (state, { getApiConstants, data }) => ({
    ...state,
    ...{ getApiConstants },
    ...{ data }
  })),
  on(deleteIndex, (state, { apiConstants, params }) => ({
    ...state,
    ...apiConstants,
    ...params
  })),
  on(deleteIndexId, (state, { indexId }) => {
    const allIndices = state?.indexObjects;
    const filteredData = allIndices.filter((index: { sid: string }) => index.sid !== indexId);
    return {
      ...state,
      indexObjects: filteredData,
      loader: false
    };
  }),
  on(deleteSuccess, (state, { deleteIndexId }) => {
    return {
      ...state,
      ...{ deleteIndexId }
    };
  }),
  on(deleteError, (state, { deleteError }) => {
    return {
      ...state,
      ...{ deleteError }
    };
  }),
  on(setError, (state, { error }) => {
    return {
      ...state,
      ...{ error }
    };
  })
);
